
(() => {
  function initShowcases() {
    document.querySelectorAll('.interactive-showcase').forEach(section => {
      if (section.dataset.showcaseInitialized === 'true') return;

      const slider = section.querySelector('#showcaseSlider');
      const items = Array.from(section.querySelectorAll('.showcase-item'));

      const prevBtn = section.querySelector('.showcase-arrow.prev');
      const nextBtn = section.querySelector('.showcase-arrow.next');
      const progress = section.querySelector('.progress-line span');

      const mainImage = section.querySelector('#mainShowcaseImage');
      const mainTitle = section.querySelector('#mainTitle');
      const mainDescription = section.querySelector('#mainDescription');
      const mainButton = section.querySelector('#mainButton');
      const reviewText = section.querySelector('#reviewText');

      if (
        !slider || !items.length || !mainImage ||
        !mainTitle || !mainDescription ||
        !mainButton || !reviewText
      ) return;

      section.dataset.showcaseInitialized = 'true';

      let currentIndex = 0;
      let sliderIndex = 0;

      function getVisibleItems() {
        if (window.innerWidth <= 480) return 1;
        if (window.innerWidth <= 1024) return 2;
        return 3;
      }

      function updateSlider() {
        const gap = parseFloat(getComputedStyle(slider).gap) || 0;
        const itemWidth = items[0].getBoundingClientRect().width + gap;
        const maxSliderIndex = Math.max(
          0,
          items.length - getVisibleItems()
        );

        sliderIndex = Math.max(
          0,
          Math.min(sliderIndex, maxSliderIndex)
        );

        slider.style.transform =
          `translateX(-${sliderIndex * itemWidth}px)`;

        if (progress) {
          progress.style.width =
            `${((currentIndex + 1) / items.length) * 100}%`;
        }
      }

      function updateContent(item) {
        const imageUrl = item.dataset.mainImage;

        if (imageUrl) {
          // Evita que el srcset anterior mantenga otra imagen.
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = imageUrl;
        }

        mainTitle.textContent = item.dataset.title || '';
        mainDescription.innerHTML = item.dataset.description || '';
        mainButton.textContent = item.dataset.button || '';
        mainButton.href = item.dataset.link || '#';
        reviewText.textContent = item.dataset.review || '';
      }

      function setActive(index) {
        if (index < 0 || index >= items.length) return;

        currentIndex = index;

        items.forEach((item, i) => {
          item.classList.toggle('active', i === currentIndex);
        });

        updateContent(items[currentIndex]);

        const visible = getVisibleItems();

        if (currentIndex < sliderIndex) {
          sliderIndex = currentIndex;
        } else if (currentIndex >= sliderIndex + visible) {
          sliderIndex = currentIndex - visible + 1;
        }

        updateSlider();
      }

      items.forEach((item, index) => {
        item.addEventListener('click', () => setActive(index));
      });

      if (nextBtn) {
        nextBtn.addEventListener('click', event => {
          event.preventDefault();

          if (currentIndex < items.length - 1) {
            setActive(currentIndex + 1);
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', event => {
          event.preventDefault();

          if (currentIndex > 0) {
            setActive(currentIndex - 1);
          }
        });
      }

      window.addEventListener('resize', updateSlider);

      setActive(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowcases);
  } else {
    initShowcases();
  }

  // Permite reinicializar la sección dentro del editor de Shopify.
  document.addEventListener('shopify:section:load', initShowcases);
})();